import React from 'react';

const CoinbaseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="682.667"
    height="682.667"
    version="1"
    viewBox="0 0 512 512"
  >
    <path
      fill="#1253F5"
      d="M2310 5114c-608-72-1108-303-1523-703-409-394-656-861-758-1436-21-115-24-161-24-410 0-224 4-302 18-390 89-542 319-1007 686-1388 394-409 861-656 1436-758 115-21 161-24 410-24 224 0 302 4 390 18 542 89 1007 319 1388 686 409 394 656 861 758 1436 21 115 24 161 24 410 0 224-4 302-18 390-89 542-319 1007-686 1388-394 409-862 656-1436 758-98 18-167 22-375 24-140 2-271 1-290-1zm381-1064c360-35 670-181 924-435 259-259 400-561 435-935 42-445-154-937-491-1231-215-189-486-319-754-364-132-22-358-22-490 0-194 32-429 126-590 235-502 341-752 953-630 1544 88 426 372 804 765 1018 154 84 369 149 557 167 123 12 164 12 274 1z"
      transform="matrix(.1 0 0 -.1 0 512)"
    />
    <path
      fill="#1253F5"
      d="M2131 3026c-50-28-50-33-51-463 0-291 3-409 12-428 24-54 33-55 468-55s444 1 468 55c9 19 12 137 12 425 0 429-1 440-51 466-39 20-822 20-858 0z"
      transform="matrix(.1 0 0 -.1 0 512)"
    />
  </svg>
);

export default CoinbaseIcon;
